import { forwardRef } from "react";

import { IsoLocale, Nullable } from "@simplyk/common";
import { FieldValues, Path } from "react-hook-form";

import { OutlinedTextFieldWysiwyg } from "../OutlinedTextFieldWysiwyg/OutlinedTextFieldWysiwyg";
import { FroalaConfig, OutlinedTextFieldWysiwygProps } from "../OutlinedTextFieldWysiwyg/type";

interface OutlinedMailFieldWysiwygProps<T extends FieldValues> extends Omit<OutlinedTextFieldWysiwygProps<T>, "id"> {
  zIndex?: number;
  isoLocale?: IsoLocale;
  height?: string | number;
  heightMax?: string | number;
  subjectName: Path<T>;
  subjectRef: React.MutableRefObject<Nullable<HTMLInputElement>>;
  attachmentKeyName?: Path<T>;
}

function OutlinedMailFieldWysiwygInternal<T extends FieldValues>(props: OutlinedMailFieldWysiwygProps<T>) {
  return (
    <OutlinedTextFieldWysiwyg<T>
      keyName={`mailFieldWysiwyg-${props.name}`}
      config={FroalaConfig.Email}
      id={props.name}
      {...props}
    />
  );
}

export const OutlinedMailFieldWysiwyg = forwardRef(OutlinedMailFieldWysiwygInternal) as <T extends FieldValues>(
  props: OutlinedMailFieldWysiwygProps<T>
) => ReturnType<typeof OutlinedMailFieldWysiwygInternal>;
